<template>
  <div class="app-layout-sub">
    <div class="app-layout-sub__left">
      <div class="app-layout-sub__toggle">
        <span v-if="!isCollapse">{{ title }}</span>
        <a class="app-layout-sub__toggle-btn" @click="toggleMenu">
          <app-svg-icon icon-class="menu"></app-svg-icon>
        </a>
      </div>
      <el-menu
        class="app-layout-sub__menu"
        :default-active="defaultActive"
        @select="handleSelect"
        @open="handleOpen"
        @close="handleClose"
        :collapse="isCollapse">
        <template v-for="item in menus" v-if="!item.meta.hidden">
          <el-submenu v-if="item.children && item.children.length > 0" :index="item.name" :key="item.name">
            <template slot="title">
              <app-svg-icon :icon-class="item.meta.icon"></app-svg-icon>
              <span slot="title">{{ item.meta.title }}</span>
            </template>
            <template v-for="item2 in item.children">
              <el-menu-item :index="item2.name" :key="item2.name">{{ item2.meta.title }}</el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item v-else :index="item.name" :key="item.name">
            <app-svg-icon :icon-class="item.meta.icon"></app-svg-icon>
            <span slot="title">{{ item.meta.title }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
    <div class="app-layout-sub__right">
      <div class="app-layout-sub__breadcrumb">
        <app-breadcrumb></app-breadcrumb>
      </div>
      <div class="app-layout-sub__content">
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
        <app-footer class="app-layout-sub__footer"></app-footer>
      </div>
    </div>
  </div>
</template>

<script>
import AppFooter from '@/components/AppFooter'
import AppBreadcrumb from '@/components/AppBreadcrumb'

const findActiveName = (currentName, parentName, menus) => {
  for (const menu of menus) {
    if (currentName === menu.name && !menu.meta.hidden) {
      return menu.name
    }

    if (currentName === menu.name && menu.meta.hidden) {
      return parentName || menu.name
    }

    if (Array.isArray(menu.children)) {
      parentName = menu.name
      const name = findActiveName(currentName, parentName, menu.children)
      if (name) return name
    }
  }

  return false
}

export default {
  name: 'AppLayoutSub',
  props: {
    title: {
      type: String,
      default: ''
    },
    menus: {
      type: Array,
      default: () => []
    }
  },
  components: {
    AppFooter,
    AppBreadcrumb
  },
  data () {
    return {
      isCollapse: false
    }
  },
  computed: {
    defaultActive () {
      let name = this.$route.name

      return findActiveName(name, '', this.menus) || name
    }
  },
  methods: {
    toggleMenu () {
      this.isCollapse = !this.isCollapse
    },
    handleSelect (key, keyPath) {
      this.$router.push({ name: key })
    },
    handleOpen (key, keyPath) {
      // console.log(key, keyPath)
      // this.$router.push({ name: key })
    },
    handleClose (key, keyPath) {
      // console.log(key, keyPath)
      // this.$router.push({ name: key })
    }
  }
}
</script>

<style lang="scss">
.app-layout-sub {
  display: flex;
  flex: 1;

  &__left {
    border-right: 1px solid #eee;
    background-color: #fff;
  }

  &__toggle {
    display: flex;
    justify-content: space-between;
    height: 36px;
    padding: 10px 15px;
    border-bottom: 1px solid #eee;
    font-size: 14px;

    &-btn {
      padding-left: 5px;
    }
  }

  &__menu {
    border-right: 0;

    &:not(.el-menu--collapse) {
      width: 200px;
    }
  }

  &__right {
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 0; // NOTE: 处理表格的响应
  }

  &__breadcrumb {
    height: 36px;
    padding: 10px 15px;
    border-bottom: 1px solid #eee;
    background-color: #fff;
  }

  &__content {
    flex: 1;
    height: 0;  // NOTE: 处理元素内滚动
    padding: 15px;
    overflow: auto;
  }

  &__footer {
    padding: 30px 0 5px;
  }
}
</style>
